// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__3BNB-","label":"styles_label__2FGdw","error":"styles_error__1G1CP"};